import { cn } from '@/lib/utils';
import { FC, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { FileInputContainer } from '../file/shared';
import { InputProps, withField } from '../withField';
import { useURLFromFile } from './useURLFromFile';

interface LogoInputProps {}

interface LogoPreviewProps {
  url: string;
  className?: string;
}

export const LogoPreview: FC<LogoPreviewProps> = ({ url, className }) => {
  return (
    <div
      className={cn('bg-contain bg-no-repeat bg-center w-44 h-[100px]', className)}
      style={{
        backgroundImage: `url(${url})`
      }}
    ></div>
  );
};

export const LogoInput: FC<InputProps<File> & LogoInputProps> = ({ onChange }) => {
  const [loading, setLoading] = useState(false);
  const readImageUrl = useURLFromFile();
  const [url, setUrl] = useState<string>();

  const onInput = async (files: File[]) => {
    setLoading(true);

    const file = files[0];
    if (!file) return;

    const url = (await readImageUrl(file)) as string;
    setUrl(url);

    onChange(file);

    setLoading(false);
  };

  const state = useDropzone({
    onDrop: onInput,
    multiple: false,
    accept: {
      'image/png': ['.png'],
      'image/jpeg': ['.jpeg', '.jpg']
    }
  });

  return (
    <div className="flex flex-col gap-4 py-4">
      <FileInputContainer
        className="flex justify-center"
        state={state}
        loading={loading}
        placeholder={`Drag and drop a file, or click to upload`}
      ></FileInputContainer>
      {url && <LogoPreview url={url} className="mx-auto " />}
    </div>
  );
};

export const LogoField = withField<File, LogoInputProps>(LogoInput);
